<template>
  <article>
    <AppBanner
      title-alignment="text-left flex-row"
      title="Edit Event"
    />

    <AppSection>
      <AppContainer>
        <AppSpinner
          v-if="loading"
          class="page-spinner"
        />

        <template v-else>
          <EventForm :event="event" />
        </template>
      </AppContainer>
    </AppSection>
  </article>
</template>

<script setup>

import {
  AppSection,
  AppContainer, AppBanner, AppSpinner,
} from '@/components/app';

import { EventForm } from '@/components/forms/admin';

import '@vuepic/vue-datepicker/dist/main.css';
import { useHttp } from '@/composables';
import { HttpStatusCode } from 'axios';
import { onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';

const event = ref(null);
const loading = ref(true);
const route = useRoute();

const loadEvent = async () => {
  loading.value = true;

  const response = await useHttp().get(`/events/${route.params.slug}`);

  if (response.statusCode === HttpStatusCode.Ok) {
    event.value = response.data;
  }

  loading.value = false;
};

onMounted(async () => {
  await loadEvent();
});

</script>
